// extracted by mini-css-extract-plugin
export default {"ProfilePage":"ProfileLayout_ProfilePage__qqUeB","Meta":"ProfileLayout_Meta__QMJnc","Content":"ProfileLayout_Content__-FYq+","Alt":"ProfileLayout_Alt__GKVmx"};